import React, { useState, useEffect } from 'react';
import firebaseApp from '../../firebase/credenciales';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import '../Login/Login.css';
import icono from '../../assets/logo.png';
import userIcon from '../../assets/user.svg';
import keyIcon from '../../assets/IconKey.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);
const auth = getAuth(firebaseApp);

const Login = () => {
    const [errors, setErrors] = useState({ email: "", password: "" });
    const [attempts, setAttempts] = useState(0);
    const [isLocked, setIsLocked] = useState(false);
    const [unlockTime, setUnlockTime] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (isLocked && unlockTime) {
            const now = new Date().getTime();
            const remainingTime = unlockTime - now;

            if (remainingTime > 0) {
                const timeout = setTimeout(() => {
                    setIsLocked(false);
                    setAttempts(0);
                    setUnlockTime(null);
                    MySwal.fire({
                        title: 'Desbloqueo',
                        text: 'Puedes intentar iniciar sesión nuevamente.',
                        icon: 'info',
                        confirmButtonText: 'Ok'
                    });
                }, remainingTime);

                return () => clearTimeout(timeout);
            }
        }
    }, [isLocked, unlockTime]);



    const submitHandler = (e) => {
        e.preventDefault();
        if (isLocked) return;

        const email = e.target.elements.email.value;
        const password = e.target.elements.password.value;
        setErrors({ email: "", password: "" });

        const emailError = validateEmail(email);
        const passwordError = validatePassword(password);

        if (emailError || passwordError) {
            setErrors({ email: emailError, password: passwordError });
            return;
        }

        signInWithEmailAndPassword(auth, email, password)
            .then((usuario) => {
                MySwal.fire({
                    title: '¡Inicio de sesión exitoso!',
                    text: 'Has iniciado sesión correctamente.',
                    confirmButtonText: 'Ok'
                });
                console.log('Usuario autenticado:', usuario);
                setAttempts(0);
            })
            .catch((error) => {
                const newAttempts = attempts + 1;
                setAttempts(newAttempts);

                if (newAttempts >= 2) {
                    setIsLocked(true);
                    setUnlockTime(new Date().getTime() + 10 * 60 * 1000);
                    MySwal.fire({
                        title: '¡Alerta!',
                        text: 'Has fallado demasiadas veces. No puedes volver a intentar hasta pasados 10 minutos.',
                        icon: 'warning',
                        confirmButtonText: 'Entendido',
                    });
                } else {
                    MySwal.fire({
                        title: 'Error',
                        text: 'Credenciales incorrectas. Intenta nuevamente.',
                        confirmButtonText: 'Intentar de nuevo'
                    });
                }

                console.log('Error al iniciar sesión:', error);
            });
    };

    const validateEmail = (email) => {
        if (!email) return "El correo electrónico es requerido.";
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) return "Por favor ingresa un correo electrónico válido.";
        return "";
    };

    const validatePassword = (password) => {
        if (!password) return "La contraseña es requerida.";
        if (password.length < 6) return "La contraseña debe tener al menos 6 caracteres.";
        return "";
    };

    return (
        <div className="login-container">
            <img className='icono' src={icono} alt="icono" />
            <form onSubmit={submitHandler} className="login-form">
                <div className="input-group">
                    <input
                        type="email"
                        placeholder=" Ingresa tu correo electrónico"
                        required
                        id="email"
                        autoComplete="off"
                        disabled={isLocked}
                        className="input-field"
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                    <img src={userIcon} className="input-icon" alt="Email Icon" />
                </div>

                <div className="input-group">
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder=" Ingresa tu contraseña"
                        required
                        id="password"
                        autoComplete="off"
                        className="input-field"
                        disabled={isLocked}
                    />
                    <img src={keyIcon} className="input-icon" alt="Password Icon" />
                    <button
                        type="button"
                        className="eyeButton"
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label="Mostrar u ocultar contraseña"
                    >
                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                    </button>
                </div>
                {errors.password && <p className="error">{errors.password}</p>}

                <button type="submit" className="submit-button" disabled={isLocked}>Iniciar Sesión</button>

            </form>
        </div>
    );
};

export default Login;
